import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { BookOpen, FileText, FileType } from "lucide-react";

export function ManualeButton({ file, route }) {
  const navigate = useNavigate();
  const open = (ext) => window.open(`/manuali/${file}.${ext}`, "_blank");

  if (route) {
    return (
      <Button variant="outline" onClick={() => navigate(route)} data-testid="manuale-btn">
        <BookOpen className="h-4 w-4 mr-2" /> Manuale operatore
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid="manuale-btn"><BookOpen className="h-4 w-4 mr-2" /> Manuale operatore</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => open("pdf")} data-testid="manuale-pdf"><FileText className="h-4 w-4 mr-2 text-red-600" /> Scarica PDF</DropdownMenuItem>
        <DropdownMenuItem onClick={() => open("docx")} data-testid="manuale-word"><FileType className="h-4 w-4 mr-2 text-blue-600" /> Scarica Word</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
